import { RemoteDeleteQuestion } from 'data/usecases';
import { makeApiUrlEvaluationCriteriaQuestions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeleteQuestion = (): RemoteDeleteQuestion => {
  return new RemoteDeleteQuestion(
    makeApiUrlEvaluationCriteriaQuestions(),
    makeAxiosHttpClient(),
  );
};
